import type { ReactNode } from 'react';
import styled from 'styled-components';

import background from './assets/background.webp';

const Root = styled.div`
  isolation: isolate;
`;

const BackgroundElement = styled.div`
  background: url(${background}) no-repeat center / cover;
  position: fixed;
  inset: 0;
  z-index: -1;
`;

type Props = {
  children: ReactNode;
};
export const Background = ({ children }: Props) => {
  return (
    <Root>
      <BackgroundElement />
      {children}
    </Root>
  );
};
